import type { ReactNode } from 'react';
import type { GridColumns } from './Grid.styled';
import Styled from './Grid.styled';

interface Props {
  children?: ReactNode;
  columns?: GridColumns;
  gap?: 'sm' | 'md' | 'lg';
  layout?: 'vertical' | 'horizontal';
}

function Grid({
  children,
  columns = '1',
  gap = 'md',
  layout = 'vertical'
}: Props) {
  return (
    <Styled.Container>
      <Styled.Root columns={columns} gap={gap} layout={layout}>
        {children}
      </Styled.Root>
    </Styled.Container>
  );
}

export default Grid;
